import React, { Suspense } from "react";
import { useMainState } from "contexts/MainStateContext";
import ModalWrapper from "components/Modal/ModalWrapper";
import modalComponents from "routes/ModalMap";

const ModalManager = () => {
  const { modalStack, closeTopModal, saveTopModal } = useMainState();

  if (!modalStack || modalStack.length === 0) return null;

  return (
    <>
      {modalStack.map((modal, index) => {
        const isTop = index === modalStack.length - 1;
        const entry = modalComponents[modal.name] || {};
        const ModalComponent =
          entry.component || modalComponents.frmerror.component;

        const { onSave, params } = modal; // 🔄 Plano, ya no hay `params: {}`

        const effectiveProps = {
          routeParams: params,
          modalProps: isTop
            ? {
                onClose: closeTopModal,
                onSave: onSave || saveTopModal || (() => {}),
              }
            : { onClose: () => {}, onSave: () => {} },
        };

        return (
          <ModalWrapper
            key={index}
            onClose={isTop ? closeTopModal : () => {}}
            onSave={isTop ? onSave || saveTopModal : () => {}}
            zIndex={1000 + index}
          >
            <Suspense fallback={<div>Carregant formulari...</div>}>
              <ModalComponent {...effectiveProps} />
            </Suspense>
          </ModalWrapper>
        );
      })}
    </>
  );
};
export default ModalManager;
